import { SelectInput } from '@thinknet-gmbh/platform-common-ui';

const BooleanSelectInput = ({
  onChange,
  t,
  value,
  disabled
}: {
  onChange?: (value: boolean) => void;
  t: Function;
  value?: boolean;
  disabled?: boolean
}) => (
  <SelectInput
    placeholder={t('common:labels.yes')}
    onChange={value => onChange && onChange(!!value)}
    value={value !== undefined ? (value ? 1 : 0) : undefined}
    disabled={disabled}
  >
    <SelectInput.Option value={1}>{t('common:labels.yes')}</SelectInput.Option>
    <SelectInput.Option value={0}>{t('common:labels.no')}</SelectInput.Option>
  </SelectInput>
);

export default BooleanSelectInput;
